import React from 'react';
import { Box, Stack } from '@mui/material';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import ArticleIcon from '@mui/icons-material/Article';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PodcastsIcon from '@mui/icons-material/Podcasts';

const SOURCES: Array<{ icon: React.ReactNode; label: string }> = [
  { icon: <SmartDisplayIcon sx={{ fontSize: 18 }} />, label: 'YouTube' },
  { icon: <LiveTvIcon sx={{ fontSize: 18 }} />, label: 'Серіали' },
  { icon: <ArticleIcon sx={{ fontSize: 18 }} />, label: 'Статті' },
  { icon: <MenuBookIcon sx={{ fontSize: 18 }} />, label: 'Книги' },
  { icon: <PodcastsIcon sx={{ fontSize: 18 }} />, label: 'Подкасти' },
];

const SourcePill: React.FC<{ icon: React.ReactNode; label: string }> = ({
  icon,
  label,
}) => (
  <Stack
    direction={'row'}
    alignItems={'center'}
    spacing={0.75}
    sx={{
      bgcolor: 'background.paper',
      border: '1px solid',
      borderColor: 'primary.tableBorder',
      borderRadius: 999,
      color: 'text.secondary',
      fontSize: 13,
      fontWeight: 600,
      px: 1.25,
      py: 0.5,
      whiteSpace: 'nowrap',
    }}
  >
    <Box
      component={'span'}
      sx={{ color: 'primary.main', display: 'inline-flex' }}
    >
      {icon}
    </Box>
    {label}
  </Stack>
);

const IASourcePills: React.FC = () => (
  <Stack direction={'row'} sx={{ flexWrap: 'wrap', gap: 0.75 }}>
    {SOURCES.map((s) => (
      <SourcePill key={s.label} icon={s.icon} label={s.label} />
    ))}
  </Stack>
);

export default IASourcePills;
